var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMerchIcon = function SvgMerchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "menu-item-merch",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 19,
    viewBox: "0 0 27.107 26.022"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4592"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.211.61a30.211 30.211 0 0 0-5.682 2.4c-.181.161-2.953 6.8-4.01 8.258-.124.2 4.768 2.04 5.677 2.4v11.854h14.715V13.67c.909-.359 5.8-2.2 5.677-2.4-1.056-1.462-3.829-8.1-4.01-8.258a30.194 30.194 0 0 0-5.682-2.4c-.727 2.757-5.965 2.756-6.691 0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 108528",
    d: "M10.664 6.099A1.114 1.114 0 0 0 9.553 7.21v5.779a1.114 1.114 0 0 0 1.111 1.11h5.779a1.114 1.114 0 0 0 1.11-1.11V7.21a1.114 1.114 0 0 0-1.11-1.111Zm0 .445h5.779a.661.661 0 0 1 .667.667v2.575l-1.4-1.4a.223.223 0 0 0-.314 0l-2.51 2.51-1.621-1.621a.222.222 0 0 0-.314 0l-.954.954v-3.02a.661.661 0 0 1 .667-.667Z"
  }))));
};
export default SvgMerchIcon;